import styled from "styled-components"

export const StyledCareersCardContainer = styled.div`
  display: flex;
  padding: 32px;
  background-color: ${(props) => props.theme.colors.white};
  margin: 0 0 16px;
  justify-content: space-between;
  box-shadow: 0 8px 16px ${(props) => props.theme.colors.darkGrey05};

  @media (max-width: 767px) {
    flex-direction: column-reverse;
    justify-content: center;
    padding: 24px;
    margin: 0 0 8px;
  }
`

export const StyledJobCardBlock = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  text-align: ${({ right }: { right?: boolean }) => right ? "right" : "inherit"};

  & p {
    ${props => props.theme.mixins.body}
  }

  
  @media (max-width: 767px) {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    
    &:nth-last-of-type(1){
      border-bottom: 1px solid ${props => props.theme.colors.darkGrey10};
      padding-bottom: 16px;
      margin-bottom: 16px;
      flex-direction: row-reverse;
    }

    h3 {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    p {
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &:nth-of-type(1){
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
    }
  }

  @media (max-width: 414px) {
    width: 100%;
    display: flex;
    flex-direction: inherit;

    &:nth-last-of-type(1) {
      border-bottom: 1px solid ${props => props.theme.colors.darkGrey10};
      padding-bottom: 16px;
      margin-bottom: 16px;
      flex-direction: inherit;

      > p {
        padding-bottom: 8px;
      }
    }
  }
`

export const StyledJobCardTitle = styled.h3`
  ${props => props.theme.mixins.bold}
  margin-bottom: 8px;
`
export const StyledLocationLabel = styled.div`
  display: flex;
  justify-content: flex-end;
  text-align: right;
  margin-bottom: 8px;

  @media (max-width: 767px) {
    margin-bottom: 0;
  }

  & p{
    ${props => props.theme.mixins.bold}
  }
`